import { createAction } from '@reduxjs/toolkit';

const setIsScanning = createAction('barcodeScanner/setIsScanning');
const unsetIsScanning = createAction('barcodeScanner/unsetIsScanning');
const appendValue = createAction('barcodeScanner/appendValue');

export { setIsScanning, unsetIsScanning, appendValue };
